import { URL_CONFIG } from "./urlConfig";

export const ATP_API_URL = {
  LOGIN: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  REQUEST_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  VERIFY_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/verify-otp`,
  PRIMARY_CREATE_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/primary-create-onboarding`,

  TOTAL_COUNTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/total-counts`,
  PARENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/parent-list`,
  UPLOAD_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/upload-document`,

  KYC_FORM_FIELDS_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/insert-kyc`,
  GET_ALL_DATA_SEARCH: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/get-entities`,
  UPDATE_FORM_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/update-entity`,

  APPROVE_ENTITY_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/approve-entity`,
  DEFICIENCY_ENTITY_NEW: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/deficiency-entity`,
  VIEW_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/view-document`,
  COMPANY_CHILD_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-parent-child`,

  ENTITY_KYC_STATUS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-kyc-status`,
  RESEND_KYC_LINK: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/resend-kyc-link`,
  UPLOAD_EXCEL: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/upload-ledger`,
  ENTITY_LEDGER_STATUS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-ledger-status`,
  DOWNLOAD_UPLOADED_FILE_LAGDER: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/download-excel`,
  ENTITY_ACTIVE_INACTIVE: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/entity-active-inactive`,
};
